import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import MenuIcon from 'material-ui-icons/Menu';
import List, { ListItem, ListItemIcon, ListItemText, ListSubheader } from 'material-ui/List';
import LogoutIcon from 'material-ui-icons/ExitToApp';

import Collapse from 'material-ui/transitions/Collapse';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import ExpandLessIcon from 'material-ui-icons/ExpandLess';
import ViewCarouselIcon from 'material-ui-icons/ViewCarousel';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { reduxForm } from 'redux-form';

import signOut from '../actions/signOut';
import defaultLogo from '../images/logo.png';
import { isUserATSysAdmin } from '../helpers/Util';
import vxcLogo from '../images/VXC.png';
import acaLogo from '../images/ACA.png';

const styles = theme => ({
    root: {
        width: '100%',
        maxWidth: 500,
        backgroundColor: theme.palette.background.paper,
    },
    list: {
        width: 350,
        overflowY: 'auto',
    },
    nested: {
        paddingLeft: theme.spacing.unit * 6,
    },
    centerDiv: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    copyrightDiv: {
        boxShadow: '0px -2px 6px -2px rgba(0,0,0,0.5)',
        position: 'absolute',
        backgroundColor: 'white',
        left: 0,
        bottom: 0,
        width: 350,
        margin: 0,
        padding: '5px 0',
        fontSize: '15px',
        height: '24px',
        lineHeight: '24px',
        textAlign: 'center',
    },
    menuIcon: {
        position: 'absolute',
        top: 0,
        left: 0,
        padding: '21px', // (91px / 2) - 24px
    },
    flipIcon: {
        transform: 'rotateY(180deg)',
    }
});


class Header extends Component {
    static getLogoForProduct(product) {
        switch (product) {
            case 'VIN Cross Check':
                return <img alt="logo" style={{ transition: '0.05s' }} src={vxcLogo} height={78} width={170} />;
            case 'AutoCheck Auctions':
                return <img alt="logo" style={{ transition: '0.05s' }} src={acaLogo} height={57} width={338} />;
            default:
                return <img alt="logo" style={{ transition: '0.05s' }} src={defaultLogo} height={78} width={123} />;
        }
    }

    state = {
        menuOpen: false,
        customerCollapse: false,
        submissionsCollapse: false,
        reportingCollapse: false,
        accountSettingsCollapse: false,
        adminMenuOpen: false,
    };

    isSection = route => !route.path && !route.component && route.section && route.text;

    isNestedLink = route => route.section && route.path && route.text;

    isTopLevelLink = route => !route.section && route.path && route.text;

    toggleMenu() {
        this.setState({ menuOpen: !this.state.menuOpen });
    }

    toggleCollapse(menu) {
        const currentState = this.state[menu] || false;
        this.setState({ [menu]: !currentState });
    }

    logout() {
        this.props.actions.signOut(this.props.data.config);
    }

    renderEmptyMenu() {
        const { classes } = this.props;
        const isSSOLogin = localStorage.getItem('isSSOLogin') ? JSON.parse(localStorage.getItem('isSSOLogin')) : false;

        return (
            <header className="App-header">
                <div className={classes.menuIcon}>
                    <IconButton
                        size="large"
                        onClick={() => this.toggleMenu()}
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
                <Drawer open={this.state.menuOpen} onClose={() => this.toggleMenu()}>
                    <List component="nav" className={classes.list} disablePadding>
                        <ListItem key="welcome-text">
                            <h3>Welcome</h3>
                        </ListItem>
                        {!isSSOLogin && <ListItem key="logout" button onClick={() => this.logout()}>
                            <ListItemIcon>
                                <LogoutIcon className={classes.flipIcon} />
                            </ListItemIcon>
                            <ListItemText inset primary="Logout" />
                        </ListItem>
                        }
                    </List>
                </Drawer>
            </header>
        );
    }

    renderRouteLinks() {
        const { classes } = this.props;
        const { routes } = this.props.data;
        if (!routes) return null;

        // the routes array will include data for all routes accessible to the current location/product/user
        // we need to filter down to only routes that include link information (text, section, icon, order, path)
        // we then want to order the 'links' using their order property so that we can render them to the
        // menu in the correct order.
        // finally, we want to map the route data to a format that makes rendering the links easier
        const orderedLinks = routes
            .filter(r => r.text) // if a route has a text property, we can assume it is a section or a link
            .sort((a, b) => a.order - b.order)
            .map(r => ({
                isSection: this.isSection(r),
                isTopLevelLink: this.isTopLevelLink(r),
                isNestedLink: this.isNestedLink(r),
                key: r.key,
                section: r.section,
                icon: r.icon,
                text: r.text,
                path: r.path,
                order: r.order,
            }));

        // iterate over the ordered links that are a section or a top-level link
        // if we hit a section:
        // - get all nested links for the current section
        // - build a List component for the section
        // - embed a Collapse component that includes ListItem components for each nested link in the section's List component
        // if we hit a top-level link:
        // - build a ListItem component for the top-level link
        return orderedLinks
            .filter(l => l.isSection || l.isTopLevelLink)
            .map((r) => {
                if (r.isSection) {
                    const isATSysAdmin = isUserATSysAdmin(localStorage.getItem('customerId'));
                    const sectionLinks = orderedLinks.filter(l => l.isNestedLink && r.section === l.section);
                    return (
                        <List key={r.key} component="div" disablePadding>
                            <ListItem key={`${r.key}-toggle`} button onClick={() => this.toggleCollapse(r.key)}>
                                {
                                    r.icon &&
                                    <ListItemIcon>
                                        {r.icon}
                                    </ListItemIcon>
                                }
                                <ListItemText inset primary={r.text} />
                                {this.state[r.key] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                            </ListItem>
                            {
                                sectionLinks &&
                                <Collapse
                                    key={`${r.key}-collapse`}
                                    in={this.state[r.key] || false}
                                    timeout="auto"
                                    unmountOnExit
                                >
                                    {
                                        sectionLinks
                                            .map(link => {
                                                if (isATSysAdmin && link.key.includes('customer')) {
                                                    return (
                                                        <ListItem
                                                            key={link.key}
                                                            button
                                                            component={Link}
                                                            to={link.path}
                                                            className={classes.nested}
                                                        >
                                                            {
                                                                link.icon &&
                                                                <ListItemIcon>
                                                                    {link.icon}
                                                                </ListItemIcon>
                                                            }
                                                            <ListItemText inset primary={link.text} />
                                                        </ListItem>
                                                    )
                                                } else if (!link.key.includes('customer')) {
                                                    return (
                                                        <ListItem
                                                            key={link.key}
                                                            button
                                                            component={Link}
                                                            to={link.path}
                                                            className={classes.nested}
                                                        >
                                                            {
                                                                link.icon &&
                                                                <ListItemIcon>
                                                                    {link.icon}
                                                                </ListItemIcon>
                                                            }
                                                            <ListItemText inset primary={link.text} />
                                                        </ListItem>
                                                    )
                                                }
                                            })
                                    }
                                </Collapse>
                            }
                        </List>
                    );
                }

                if (r.isTopLevelLink) {
                    return (
                        <ListItem
                            key={r.key}
                            button
                            component={Link}
                            to={r.path}
                        >
                            {
                                r.icon &&
                                <ListItemIcon>
                                    {r.icon}
                                </ListItemIcon>
                            }
                            <ListItemText inset primary={r.text} />
                        </ListItem>
                    );
                }

                return null;
            });
    }

    renderCommonLinks() {
        const { classes } = this.props;
        const { routes } = this.props.data;
        const isSSOLogin = localStorage.getItem('isSSOLogin') ? JSON.parse(localStorage.getItem('isSSOLogin')) : false;
        //const showChangeProduct = localStorage.getItem('showChangeProduct');
        const hideMenuItems = window.location.href.includes('/selector');

        return (
            <List component="div" disablePadding>
                {
                    (routes && !isSSOLogin && !hideMenuItems) &&
                    <ListItem key="selector" button component={Link} to="/selector">
                        <ListItemIcon>
                            <ViewCarouselIcon />
                        </ListItemIcon>
                        <ListItemText inset primary="Change Locations or Products" />
                    </ListItem>
                }
                {!isSSOLogin && <ListItem key="logout" button onClick={() => this.logout()}>
                    <ListItemIcon>
                        <LogoutIcon className={classes.flipIcon} />
                    </ListItemIcon>
                    <ListItemText inset primary="Logout" />
                </ListItem>
                }
            </List>
        );
    }

    renderCopyright() {
        const { classes } = this.props;

        return (
            <div className={classes.copyrightDiv}>
                <img src="autotec_logo.png" height={18} style={{ marginRight: '4px', marginBottom: '-4px' }} alt="logo" />
                <span>&copy; {new Date().getFullYear()} AutoTec, LLC.</span>
            </div>
        );
    }

    render() {
        const { person } = this.props.data;
        if (!person) return this.renderEmptyMenu();

        const { classes } = this.props;

        return (
            <header className="App-header">
                <div className={classes.menuIcon}>
                    <IconButton
                        onClick={() => this.toggleMenu()}
                        size="large"
                    >
                        <MenuIcon />
                    </IconButton>
                </div>
                <div className={classes.centerDiv}>
                    <Link to="/" href="/">{Header.getLogoForProduct(sessionStorage.getItem('product'))}</Link>
                </div>
                <Drawer open={this.state.menuOpen} onClose={() => this.toggleMenu()}>
                    <List component="nav" className={classes.list} disablePadding>
                        <ListSubheader component="div">
                            <h3>Welcome, {person.firstName} {person.lastName}</h3>
                        </ListSubheader>
                        {
                            window.location.href.includes('/selector')
                                ? null
                                : this.renderRouteLinks()
                        }
                        {this.renderCommonLinks()}
                    </List>
                    {this.renderCopyright()}
                </Drawer>
            </header>
        );
    }
}

const mapStateToProps = state => ({
    data: {
        config: state.config.config,
        person: state.person.person,
        routes: state.routes.routes,
    }
});

const mapDispatchToProps = dispatch => ({
    actions: {
        signOut: (config) => {
            dispatch(signOut(config));
        }
    }
});

Header.propTypes = {
    classes: PropTypes.shape().isRequired
};

const ConnectedHeader = connect(
    mapStateToProps,
    mapDispatchToProps
)(Header);

export default withStyles(styles)(reduxForm({ form: 'HeaderSearchForm' })(ConnectedHeader));


// WEBPACK FOOTER //
// ./src/components/Header.js